var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc/rss"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.79907 11.8348C7.87029 11.8348 9.85667 12.6576 11.3212 14.1222C12.7858 15.5867 13.6086 17.5731 13.6086 19.6443M5.79907 5.76074C9.48123 5.76074 13.0126 7.22347 15.6163 9.82715C18.2199 12.4308 19.6827 15.9622 19.6827 19.6443M7.53452 18.7766C7.53452 19.2558 7.14603 19.6443 6.6668 19.6443C6.18757 19.6443 5.79907 19.2558 5.79907 18.7766C5.79907 18.2974 6.18757 17.9089 6.6668 17.9089C7.14603 17.9089 7.53452 18.2974 7.53452 18.7766Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.51852,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.e5e70fa1adeef590d06aabe8e08a76c7.svg";
export { ForwardRef as ReactComponent };